import { render, staticRenderFns } from "./QuizTimer.vue?vue&type=template&id=2b7998f0&scoped=true&"
import script from "./QuizTimer.vue?vue&type=script&lang=js&"
export * from "./QuizTimer.vue?vue&type=script&lang=js&"
import style0 from "./QuizTimer.vue?vue&type=style&index=0&id=2b7998f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7998f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
